import instanceAxios from "./intanceAxios";



export const otService = {
    createOTWithTasks: async (data) =>  await instanceAxios.post(`/otask/ot/`, data),
    getOtByHash: async (hash) =>  await instanceAxios.get(`/otask/ot/`, {params: {hash_code: hash}}),
    getOtCalculateCompleted: async (hash) =>  await instanceAxios.get(`/otask/ot-calculate-completed/`, {params: {hash_code: hash}}),
    sendOTStatus: async (data) =>  await instanceAxios.post(`/otask/ot-change-status/`, data),
    getOtPdf: async (hash) =>  await instanceAxios.get(`/otask/ot-pdf/${hash}`, {responseType: 'blob'}),
    getOtHistory: async (hash) =>  await instanceAxios.get(`/otask/ot-history/`, {params: {hash_code: hash}}),
    changeAsignedOt: async (data) =>  await instanceAxios.post(`/otask/ot-change-asigned-ot/`, data)
        
            
            
} 